import React from 'react';
import cx from 'classnames';
import styles from './CompletionToggle.m.sass';
import ProgressSpinner from '../../../../components/ProgressSpinner';
var CompletionToggle = function CompletionToggle(_ref) {
  var completed = _ref.completed,
    onClick = _ref.onClick,
    avatar = _ref.avatar,
    title = _ref.title,
    processing = _ref.processing,
    readOnly = _ref.readOnly,
    pulse = _ref.pulse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  var click = function click() {
    return !processing && onClick();
  };
  var styleProps = {
    width: size,
    height: size
  };
  return /*#__PURE__*/React.createElement("button", {
    className: cx(styles.root, !readOnly && styles.toggleable),
    onClick: click,
    title: title,
    style: styleProps
  }, processing ? /*#__PURE__*/React.createElement(ProgressSpinner, {
    thickness: 2,
    blue: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.back, pulse && styles.pulse),
    style: styleProps
  }), completed && /*#__PURE__*/React.createElement("div", {
    className: styles.front,
    style: styleProps
  }, avatar && /*#__PURE__*/React.createElement("img", {
    src: avatar,
    alt: title,
    className: styles.avatar,
    style: styleProps
  }), /*#__PURE__*/React.createElement("img", {
    src: require('./checkbox.svg'),
    alt: "Completed",
    className: cx(styles.checkmark, !avatar && styles.enlarged),
    style: styleProps
  }))));
};
export default CompletionToggle;
//# sourceMappingURL=index.js.map
